import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['preview', 'error'];
  static values = { url: String };

  disconnect() {
    clearTimeout(this.timer);
    this.request?.abort();
  }

  schedule() {
    clearTimeout(this.timer);
    this.request?.abort();
    this.timer = setTimeout(() => this.preview(), 250);
  }

  async preview() {
    const request = new AbortController();
    this.request = request;
    const body = new FormData(this.element);
    body.delete('_method');
    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        body,
        headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '' },
        signal: request.signal
      });
      const result = await response.json();
      if (request.signal.aborted) return;
      this.errorTarget.textContent = result.error || '';
      // Only server-rendered, sanitized markup ever enters the document.
      if (response.ok) this.previewTarget.innerHTML = result.html;
      else this.previewTarget.replaceChildren();
    } catch (error) {
      if (error.name !== 'AbortError' && !request.signal.aborted) {
        this.errorTarget.textContent = 'Preview unavailable. You can still save the condition.';
      }
    }
  }
}
